export default "__VITE_ASSET__ClI_5aGx__"